(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("cki1U", function(module, exports) {
const $8f95569e2c6efb66$var$vivenuInit = ()=>{
    const script = document.createElement("script");
    script.src = "https://vivenu.com/web/deliver/js/v1/embed.js";
    script.async = true;
    script.onload = ()=>{
        if (VIVENU) {
            console.log("VIVENU loaded", VIVENU);
            VIVENU.onCheckoutCompleted = (checkout)=>{
                console.log("Checkout completed:", checkout);
            };
            VIVENU.onTicketPersonalized = (ticketInfo)=>{
                console.log("Ticket personalized:", ticketInfo);
            };
        } else console.error("VIVENU is not available after script load");
    };
    script.onerror = ()=>{
        console.error("Failed to load the VIVENU script.");
    };
    document.body.appendChild(script);
};
$8f95569e2c6efb66$var$vivenuInit();

});

})();
//# sourceMappingURL=vivenu.f4167fd1.js.map
